import Skeleton from '@mui/material/Skeleton';
import { Array as A } from 'effect';

// DA-19731: the placeholder shapes for the categorization bar, shared by WorkspaceDoctypeTabs and
// WorkspaceSubtypeChips. Only the shapes live here — each caller keeps its own wrapper so the box
// stays defined next to the real component it stands in for (the tab bar's metrics next to
// StyledTabs, the chip row's padding next to ChipRow). Copying the wrappers here instead would
// re-create the drift this ticket is about.
const CategorizationSkeletons = ({
  count,
  width,
  height,
  radius,
}: {
  count: number;
  width: number;
  height: number;
  radius?: number;
}) => (
  <>
    {A.makeBy(count, (i) => (
      <Skeleton
        key={i}
        variant="rounded"
        width={width}
        height={height}
        sx={radius ? { borderRadius: radius } : undefined}
      />
    ))}
  </>
);

export default CategorizationSkeletons;
